import { useTranslation } from 'react-i18next';
import SlideOver from '../SlideOver/SlideOver';
import CommissionOfferForm from '../CommissionOfferForm/CommissionOfferForm';
import type { UseCommissionOfferEditorResult } from '../../hooks/useCommissionOfferEditor';

interface CommissionOfferEditorSlideOverProps {
  editor: UseCommissionOfferEditorResult;
}

export default function CommissionOfferEditorSlideOver({ editor }: CommissionOfferEditorSlideOverProps) {
  const { t } = useTranslation();
  const {
    editOpen,
    formData,
    setFormData,
    isSaving,
    closeEditor,
    handleSave,
    setEditOpen,
  } = editor;

  return (
    <SlideOver
      isOpen={editOpen}
      setIsOpen={(open: boolean) => {
        if (!open) {
          closeEditor();
        } else {
          setEditOpen(true);
        }
      }}
      title={formData.name || t('commission_payment_offers.new_option') || 'New offer'}
      primaryButton={{
        label: t('global.save') || 'Save',
        onClick: () => void handleSave(),
      }}
      secondaryButton={{
        label: t('global.cancel') || 'Cancel',
        onClick: closeEditor,
      }}
      isLoading={isSaving}
    >
      <CommissionOfferForm
        offer={formData}
        onChange={setFormData}
        formKey={formData.id ?? 'new'}
      />
    </SlideOver>
  );
}
